import React from 'react';
import { FlatList } from 'react-native-gesture-handler';
import { OrganizationCard, CardItem, CampaignCard } from '../list-items/CardItem';
import { Card, Text, Layout, Button, Icon } from '../_primatives';
import { Platform } from 'react-native';

const HEADER_TOP_MARGIN: number = Platform.OS === 'web' ? 0 : -2;

export const CampaignList = ({ data, navigation, pageSpacerHorizontal, product_plan_title, highlightColor }: CampaignListProps) => {
    const renderHeader = (): React.ReactElement => (
        <Card style={{ marginTop: HEADER_TOP_MARGIN, borderBottomLeftRadius: 0, borderBottomRightRadius: 0, borderBottomWidth: 0 }}>
            <Text category='h1'>{'Campaigns'}</Text>
            <Text category='p1'>You have {`${data.campaigns.length} campaign${data.campaigns.length === 1 ? '' : 's'}`}</Text>
            <Layout style={{ flexDirection: 'row', justifyContent: 'space-between', flexWrap: 'wrap', paddingTop: 12 }}>
                {(product_plan_title === 'Premium' || product_plan_title === 'Platinum') ? (
                    <Button
                        onPress={() => navigation.navigate('CreateCampaign')}
                        status='basic'
                        // size={Platform.OS === 'web' ? 'medium' : 'small'}
                        icon={(style) => <Icon {...style} name='plus-circle-outline' />}
                    >
                        {`Create Campaign`}
                    </Button>
                ) : (
                        <Text appearance='hint'>{`Only Premium and Platinum plans have the ability to create a campaign.`}</Text>
                    )}
            </Layout>
        </Card>
    );
    const renderFooter = (): React.ReactElement => (
        <Card style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, borderTopWidth: 0 }}>
            <Text category='p1'>{'\n'}</Text>
        </Card>
    );
    const renderCampaign = ({ item }) => (
        <CampaignCard
            item={item}
            onPress={() => navigation.navigate('Campaign', { campaign: item.id })}
            style={{ borderTopWidth: 0, borderBottomWidth: 0 }}
        />
    );
    const keyExtractor = (item: CardItem) => item.id;

    return (
        <FlatList
            data={data.campaigns}
            renderItem={renderCampaign}
            style={{ flex: 1, padding: pageSpacerHorizontal }}
            keyExtractor={keyExtractor}
            ListHeaderComponent={renderHeader}
            ListFooterComponent={renderFooter}
        />
    );
}


export interface CampaignListProps {
    data: any;
    navigation: any;
    pageSpacerHorizontal: number;
    product_plan_title?: string;
    highlightColor?: string;
}